import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import {
  COMPANY_NAME_MALFORMED,
  IDENTIFIER_MALFORMED,
  MISSING_DATE_OF_BIRTH,
  MISSING_IDENTIFIER,
  MISSING_IDENTIFIER_QUALIFIER,
  QUALIFIER_MALFORMED,
  WRONG_IDENTIFIER_FORMAT,
  WRONG_IDENTIFIER_LENGTH,
} from '@constants/entity-validation-messages';
import { ValidationMessageModel } from '@data-layer/models/common';
import { EntityModel } from '@data-layer/models/entities';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { EntrySummaryValidationHelper } from '@helpers/entry-summary-validation.helper';

@Component({
  selector: 'es-details-importer-card',
  templateUrl: './es-details-importer-card.component.html',
  styleUrls: ['./es-details-importer-card.component.scss'],
})
export class EsDetailsImporterCardComponent implements OnInit, OnChanges {
  @Input() public entrySummary: EntrySummaryModel;
  @Input() public canEdit = false;
  @Output() public edit = new EventEmitter();
  public info = {
    title: 'LABELS.IMPORTER_INFO',
    imgSrc: 'importer',
  };
  public importer: EntityModel = null;
  public isEmpty = true;
  public allValidationMessages: ValidationMessageModel[] = [];

  private readonly missingFields = [
    MISSING_DATE_OF_BIRTH,
    MISSING_IDENTIFIER,
    MISSING_IDENTIFIER_QUALIFIER,
    WRONG_IDENTIFIER_LENGTH,
    WRONG_IDENTIFIER_FORMAT,
    COMPANY_NAME_MALFORMED,
    QUALIFIER_MALFORMED,
    IDENTIFIER_MALFORMED,
  ];
  constructor() {}

  public ngOnInit(): void {
    this.updateImporter();
  }

  public ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.entrySummary) {
      this.updateImporter();
      this.checkIsMissing();
    }
  }

  public onEdit() {
    this.edit.emit();
  }

  private updateImporter() {
    if (this.entrySummary?.importer) {
      this.importer = this.entrySummary.importer;
    }
  }

  private checkIsMissing() {
    if (!!this.entrySummary?.importer) {
      this.isEmpty = false;
    } else {
      this.isEmpty = true;
      return;
    }

    const allValidationMessages = EntrySummaryValidationHelper.getImporterValidationMessages(
      this.importer,
      this.entrySummary.transportationMode,
    );
    this.allValidationMessages = [];
    for (const mess of allValidationMessages) {
      this.allValidationMessages.push(mess);
    }
    const addressValidationMessages: ValidationMessageModel[] =
      this.importer && this.importer.address && this.importer.address.validationMessages
        ? (Object.values(this.importer.address.validationMessages) as any[])
        : [];
    this.allValidationMessages.push(...addressValidationMessages);
  }
}
